module.exports = __webpack_public_path__ + "static/media/wedding.162d801f.jpg";